export const products = [
    {
      id: 1,
      title: "Thyronorm 75mcg",
      // description: "Thyronorm 75mcg",
      price: "142.93",
      img: "https://www.practostatic.com/practopedia-images/v3/res-750/thyronorm-75mcg-tablet-120s_ac41f26e-04bf-41c4-be11-5c75dffe3e2f.JPG",
      amount: 1,
    },
    {
      id: 2,
      title: "Lipitor (Atorvastatin Calcium)",
      // description: "white in color",
      price: "2300",
      img: "https://cdn.shopify.com/s/files/1/0562/3853/8907/products/lipitor-_atorvastatin-calcium_-20mg-x30-tabs-1_kjvg2h_800x.jpg",
      amount: 1,
    },
    {
      id: 3,
      title: "Calcimax Forte",
      // description: "black in color",
      price: "143.50",
      img: "https://5.imimg.com/data5/ED/GY/IH/GLADMIN-3061/calcimax-forte-nutritional-supplement-tablet-30-tab-bottle-500x500.jpg",
      amount: 1,
    },
    {
      id: 4,
      title: "Liveasy Wellness Calcium,",
      // description: "Best mobile ever",
      price: "299.5",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/T22634/liveasy-wellness-calcium-magnesium-vitamin-d3-zinc-bones-dental-health-bottle-60-tabs-2-1643876895.jpg",
      amount: 1,
    },
    {
      id: 5,
      title: "Everherb Jointcare",
      // description: "black in color",
      price: "499.5",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/Y79593/everherb-jointcare-blend-of-9-powerful-herbs-joint-bone-health-bottle-of-60-tablets-2-1643876387.jpg",
      amount: 1,
    },
    {
      id: 6,
      title: "Electric Heating Wrap Black",
      // description: "black in color",
      price: "1119",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/R05584/jus-amazin-crunchy-organic-peanut-butter-unsweetened-1kg-clean-nutrition-2-1642006742.jpg",
      amount: 1,
    },
    {
      id: 7,
      title: "Nepro Hp Vanilla Nutrition",
      // description: "black in color",
      price: "722.5",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/I13844/nepro-hp-vanilla-toffee-flav-pow-400gm-2-1641787950.jpg",
      amount: 1,
    },
    {
      id: 8,
      title: "Relief Diphenhydramine HCl",
      // description: "Best mobile ever",
      price: "819.44",
      img: "https://m.media-amazon.com/images/I/81ROkatqrLL._AC_SL1500_.jpg",
      amount: 1,
    },
    {
      id: 9,
      title: "Horlicks Diabetes Plus",
      price: "680",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/G19410/horlicks-diabetes-plus-vanilla-400-g-jar-3-1654169598.jpg",
      amount: 1,
    },
    {
      id: 10,
      title: "Bold Care Surge",
      price: "599.5",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/J47511/bold-care-surge-60-tablets-2-1641792358.jpg",
      amount: 11,
    },
    {
      id: 11,
      title: "Nivea Sun Moisturising",
      price: "200",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/I40936/nivea-sun-moisturising-lotion-spf-50-75ml-2-1641788374.jpg",
      amount: 8,
    },
    {
      id: 12,
      title: "Indulekha Hair Oil",
      price: "380.16",
      img: "https://cdn01.pharmeasy.in/dam/products_otc/I14061/indulekha-bringha-hair-oil-bottle-of-50-ml-2-1654167331.jpg",
      amount: 4,
    },
  ];